// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.implantabledevice.UpdatePatientImplantableDeviceRequest */
/* istanbul ignore next */
@GandalfModel
export class UpdatePatientImplantableDeviceRequest extends GandalfModelBase {

	@GandalfLabel('Location')
	@GandalfProperty({ designType: Number })
	bodyLocationId!: number | null;

	@GandalfLabel('Comments')
	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfLabel('Implantable Device')
	@GandalfValidator({ notNull: { message: 'Implantable Device is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	implantableDeviceId!: number;

	@GandalfLabel('Date')
	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	installedDate!: Date | null;

	@GandalfLabel('Date Is Estimated')
	@GandalfValidator({ notNull: { message: 'Date Is Estimated is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isInstalledDateEstimated!: boolean;

	@GandalfLabel('Surgeon')
	@GandalfProperty({ designType: Number })
	surgeonId!: number | null;

	@GandalfLabel('UDI')
	@GandalfValidator({ notNull: { message: 'UDI is required' } })
	@GandalfValidator({ sizeString: { message: 'UDI must be between 1 and 87 characters', minLength: 1, maxLength: 87 } })
	@GandalfProperty({ designType: String, isRequired: true })
	udi!: string;

}
